// extracted by mini-css-extract-plugin
export var badge = "_gh-2";
export var detailsPanel = "_gh-0";
export var resultRow = "_gh-1";